import { render, staticRenderFns } from "./ReportListTableComponent.vue?vue&type=template&id=6be14e74&"
import script from "./ReportListTableComponent.vue?vue&type=script&lang=js&"
export * from "./ReportListTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports